import { render, staticRenderFns } from "./addTenderAnnouncement.vue?vue&type=template&id=f6a1b4ec&scoped=true"
import script from "./addTenderAnnouncement.vue?vue&type=script&lang=js"
export * from "./addTenderAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./addTenderAnnouncement.vue?vue&type=style&index=0&id=f6a1b4ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a1b4ec",
  null
  
)

export default component.exports